import { QuestionType } from '@repo/types/enums/questionType';
import { infer as Infer, z } from 'zod';

import { questionBaseSchema } from './question.schema';

export const questionSingleChoiceAnswerSchema = z.object({
  id: z.string(),
  content: z.string().min(1, 'Opis jest wymagany').max(512),
  correct: z.boolean(),
  explanation: z.string().optional(),
});

export const questionSingleChoiceSchema = questionBaseSchema.extend({
  type: z.literal(QuestionType.SINGLE),
  answers: z.array(questionSingleChoiceAnswerSchema).min(2, 'Minimum 2 odpowiedzi').max(5, 'Maksimum 5 odpowiedzi'),
});

export type QuestionSingleChoiceSchema = Infer<typeof questionSingleChoiceSchema>;

export type QuestionSingleChoiceAnswerSchema = Infer<typeof questionSingleChoiceAnswerSchema>;
